import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function StatCard({ label, value, sublabel, accent = "emerald", icon: Icon, testId }) {
  const accentMap = {
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-100",
    sky: "bg-sky-50 text-sky-700 border-sky-100",
    amber: "bg-amber-50 text-amber-700 border-amber-100",
    slate: "bg-slate-50 text-slate-700 border-slate-100",
  };
  return (
    <Card className="border-gray-200 shadow-none rounded-2xl" data-testid={testId}>
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div>
            <div className="text-xs uppercase tracking-[0.18em] text-gray-500 font-medium">{label}</div>
            <div className="text-2xl lg:text-3xl font-display font-bold mt-1.5 text-gray-900">{value}</div>
            {sublabel && <div className="text-xs text-gray-500 mt-1">{sublabel}</div>}
          </div>
          {Icon && (
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center border ${accentMap[accent]}`}>
              <Icon className="w-5 h-5" />
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
